import axios from 'axios'
import store from '@/store'

const prefix = "https://api.applefurniture.com.hk/v1" // "http://localhost:8000/v1" // "https://api.applefurniture.com.hk/v1"

let invoices = (() => {
  const path = prefix + '/invoices'
  return {
    get_path(p) {
      return axios.get(p)
    },
    get(id=null, paras=null) {
      if (id) return axios.get(path + `/${id}`)
      else {
        let new_path = path
        if (paras && Object.keys(paras).length > 0) {
          new_path = `${path}?`
          for (let key in paras) new_path += `${key}=${encodeURIComponent(paras[key])}&`
          new_path = new_path.slice(0, -1);
        }
        return axios.get(new_path)
      }
    },
    post(p=null, data={}, options={}) {
      if (p) return axios.post(path + `/${p}`,  data, options)
      return axios.post(path, data)
    },
    put(invoice_id=null, data={}, options={}) {
      if (invoice_id) return axios.put(path + `${invoice_id}/`,  data, options)
      throw "Invoice id has to be provided in order to update."
    },
    patch(p=null, data, options) {
      if (p) return axios.patch(path + `/${p}`,  data, options)
      throw "Invoice id has to be provided in order to update."
    },
    delete(id=null) {
      if (id) return axios.delete(path + `/${id}`)
      throw "Invoice id has to be provided in order to update."
    },
    mark(invoice=null) {
      if (invoice) return axios.patch(path + `/${invoice.invoice_id}`,  { marked: !invoice.marked })
      throw "Invoice id has to be provided in order to update."
    },
    generate(id=null) {
      if (id) return axios.get(path + `/${id}/generate`)
      throw "Invoice id has to be provided in order to update."
    },
    send(id=null) {
      if (id) return axios.get(path + `/${id}/send`)
      throw "Invoice id has to be provided in order to update."
    }
  }
})()

let branches = (() => {
  const path = prefix + '/branches'
  return {
    get(id=null) {
      if (id) return axios.get(path + `${id}/`)
      return axios.get(path)
    }
  }
})()

let managers = (() => {
  const path = prefix + '/managers'
  return {
    get() {
      return axios.get(path)
    }
  }
})()

let suppliers = (() => {
  const path = prefix + '/suppliers'
  return {
    get() {
      return axios.get(path)
    }
  }
})()

let files = (() => {
  const path = prefix + '/files'
  return {
    get(p=null) {
      return axios.get(p || path)
    },
    create(data) {
      return axios.post(path, data)
    }
  }
})()

let products = (() => {
  const path = prefix + '/products'
  return {
    get(p=null) {
      return axios.get(p || path)
    },
  }
})()

let token = (() => {
  const path = prefix + '/token'
  const refresh_path = prefix + '/token/refresh'
  return {
    set(t) {
      axios.defaults.headers.common['Authorization'] = `JWT ${t}`
    },
    get(username, password) {
      return axios.post(path, {'username': username, 'password': password}).then(response => {
        axios.defaults.headers.common['Authorization'] = `JWT ${response.data.access}`
        return response.data
      })
    },
    async refresh(token) {
      let response = await axios.post(refresh_path, {'refresh': token})
      axios.defaults.headers.common['Authorization'] = `JWT ${response.data.access}`
      return response.data
    }
  }
})()

let options = (() => {
  const path = prefix + '/options'
  return {
    get() {
      return axios.options(path)
    }
  }
})()

axios.interceptors.response.use((response) => response, async (error) => {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    console.log(originalRequest)
    if (originalRequest.url === prefix + '/token/refresh') {
      store.dispatch('logout')
    } else {
      originalRequest._retry = true;
      let token = await store.dispatch('refresh')
      originalRequest.headers.Authorization = `JWT ${token.access}`
      return axios(originalRequest);
    }
  }
  return Promise.reject(error);
});

export default {
  invoices,
  branches,
  managers,
  token,
  files,
  products,
  options,
  suppliers
}
export { invoices, branches, token, managers, files, products, options, suppliers }



// WEBPACK FOOTER //
// ./src/api.js